import _ from 'lodash';

import { BasicAuthCredentials } from 'models/lookup_api_config';
import OpenModal from 'actions/modal/open_modal';
import Webhook from 'models/webhook';
import WebhookVerification from 'models/modal/webhook_verification';

export default class SaveWebhook {
  constructor(context) {
    this.context = context;
  }

  run({ webhook, isExisting }) {
    if (webhook.headers) {
      let headersToSave = _.reduce(
        webhook.headers,
        (accumulator, kvTuple) => {
          return _.assign(accumulator, { [kvTuple.name]: kvTuple.value });
        },
        {}
      );

      webhook.headers = headersToSave;
    }

    if (!_.isEmpty(webhook.credentials)) {
      webhook.credentials = BasicAuthCredentials.create(webhook.credentials);
    }

    if (isExisting) {
      let webhookToSave = this.context.stores.webhooks.find(webhook.id);
      webhookToSave.update(webhook);

      this.context.gateways.webhook.update({ webhookId: webhook.id }, webhook);
      this.context.stores.webhooks.setPending(webhookToSave);
    } else {
      this.context.gateways.webhook.add({}, webhook);
      this.context.stores.webhooks.setPendingNew(Webhook.create(webhook));
    }
    this.context.executeAction(OpenModal, WebhookVerification.create());
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/webhooks/save_webhook.js